/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { candidateSubmissions } from '../../axios/candidateSubmissions'
import type {
	CandidateSubmissionsError,
	CandidateSubmissionsPathParams,
	CandidateSubmissionsResponse,
} from '../../types/CandidateSubmissions'

export const candidateSubmissionsQueryKey = (candidate: CandidateSubmissionsPathParams['candidate']) =>
	[{ url: '/candidates/:candidate/submissions', params: { candidate } }] as const

export type CandidateSubmissionsQueryKey = ReturnType<typeof candidateSubmissionsQueryKey>

/** @see backend/nexus/modules/Campaign/Http/Controllers/CandidateController.php CandidateController::submissions */
export function candidateSubmissionsQueryOptions(
	candidate: CandidateSubmissionsPathParams['candidate'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		CandidateSubmissionsResponse,
		AxiosError<CandidateSubmissionsError>,
		CandidateSubmissionsResponse,
		CandidateSubmissionsQueryKey
	>({
		queryKey: candidateSubmissionsQueryKey(candidate),
		queryFn: ({ signal }) => candidateSubmissions(candidate, { signal, ...config }).then(res => res.data),
		enabled: !!candidate,
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CandidateController.php CandidateController::submissions */
export function useCandidateSubmissions<TSelectData = CandidateSubmissionsResponse>(
	candidate: CandidateSubmissionsPathParams['candidate'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					CandidateSubmissionsResponse,
					AxiosError<CandidateSubmissionsError>,
					TSelectData,
					CandidateSubmissionsQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<CandidateSubmissionsError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...candidateSubmissionsQueryOptions(candidate),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CandidateController.php CandidateController::submissions */
export function useCandidateSubmissionsSuspense<TSelectData = CandidateSubmissionsResponse>(
	candidate: CandidateSubmissionsPathParams['candidate'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					CandidateSubmissionsResponse,
					AxiosError<CandidateSubmissionsError>,
					TSelectData,
					CandidateSubmissionsQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<CandidateSubmissionsError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...candidateSubmissionsQueryOptions(candidate),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
